import React, { useEffect, useState } from 'react'
import Topbar from '../components/Layout/Topbar'
import { Sidebar } from '../components/Layout/Sidebar'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { supabase } from '../supabase.config'
import ViewOrderDetails from '../components/ViewOrder/ViewOrderDetails'
import { useDispatch, useSelector } from 'react-redux'
import { generateToken } from '../actions/shippingActions'
import axios from 'axios'
import UpdateStatusModal from '../components/ViewOrder/UpdateStatusModal'
import { io } from "socket.io-client";
import { uploadFile, getFileUrl } from '../supabase.config'
import toast, { Toaster } from 'react-hot-toast'
import { emitOrderNotification } from '../utils/notificationService'
import { syncDeliveryAssignmentStatusForOrder } from '../utils/deliveryAssignmentService'
const ViewOrder = () => {
  const { id } = useParams()
  const [orderDetail, setOrderDetail] = useState({})
  const [deliveryBoys, setDeliveryBoys] = useState([])
  const [deliveryBoy, setDeliveryBoy] = useState({})
  const [forwardingNumber, setForwardingNumber] = useState("")
  const [wayBill, setWayBill] = useState([])
  const [orderActivity, setOrderActivity] = useState([])
  const [updateModal, setUpdateModal] = useState(false)
  const [loadingPod, setloadingPod] = useState(false)
  const [manualStatus, setManualStatus] = useState({
    status: "",
    remark: "",
    location: "",
    deliveryDate: "",
  })
  const handleUpdateModal = () => {
    setUpdateModal(!updateModal)
  }

  // const location = useLocation();

  // const navigate = useNavigate();
  // const page = new URLSearchParams(location.search).get("page") || 0;

  // console.log(page)

  // const goBack = () => {
  //   navigate(`/orders?page=${page}`);
  // };


  const { shippingToken } = useSelector(
    (state) => state.shippingToken
  );
  const { userProfile, users } = useSelector((state) => state.user)
  const actorUserId = userProfile?.id || userProfile?.uid || users || null
  const dispatch = useDispatch()
  const parseJSON = (v) => {
    if (!v) return null; if (typeof v === 'object') return v; try { return JSON.parse(v) } catch { return null }
  }
  const generateForwardingNumber = async () => {
    dispatch(generateToken())
    if (shippingToken?.jwt?.length !== 0 && orderDetail?.job_id) {
      const date = new Date()
      const newActivity = { status: "In-Transit", remark: "Order has been Shipped to Partner", location: "GRC, Bhiwandi", time: date }
      var config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://btob.api.delhivery.com/v3/manifest?job_id=' + orderDetail?.job_id,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + shippingToken?.jwt
        },

      };
      try {
        const response = await axios(config)
        const lrnum = response?.data?.status?.value?.lrnum
        const waybills = response?.data?.status?.value?.waybills
        const master_waybill = response?.data?.status?.value?.master_waybill
        const { data: current, error } = await supabase.from('orders').select('*').eq('id', id).single()
        if (error) throw error
        const pkg = parseJSON(current?.package_details) || {}
        const updatedPkg = { ...pkg, deliveryWaybill: waybills, deliveryMasterWaybill: master_waybill, orderActivity: [...(pkg.orderActivity||[]), newActivity] }
        await supabase.from('orders').update({ status: 'in-transit', forwarding_number: lrnum, package_details: JSON.stringify(updatedPkg) }).eq('id', id)
        await emitOrderNotification({
          actorUserId,
          order: { ...current, status: 'in-transit', forwarding_number: lrnum, package_details: updatedPkg },
          eventType: 'order_in_transit',
          title: 'Order shipped to partner',
          message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} moved in transit.`,
        })
        setOrderDetail(prev => ({ ...prev, orderStatus: 'in-transit', forwardingNumber: lrnum, deliveryWaybill: waybills, deliveryMasterWaybill: master_waybill, orderActivity: [...(prev.orderActivity||[]), newActivity] }))
      } catch (error) {
        alert("Error:" + error.message)
      }
    }

  }
  const handleManulOrder = async () => {
    const shouldUseDeliveryDateTime = ['Out for Delivery', 'delivered'].includes(manualStatus.status)

    if (manualStatus.status === "") {
      alert("Choose a Status")
    }
    else if (manualStatus.location === "") {
      alert("Enter Location")
    }
    else {
      const activityTime = shouldUseDeliveryDateTime && manualStatus.deliveryDate
        ? new Date(`${manualStatus.deliveryDate}T00:00:00`)
        : new Date()
      const current = await getOrderRow(id)
      if (!current) {
        alert('Order not found')
        return
      }
      const pkg = parseJSON(current?.package_details) || {}
      const newAct = {
        status: manualStatus.status,
        remark: manualStatus.remark,
        location: manualStatus.location,
        deliveryDate: manualStatus.deliveryDate,
        time: activityTime
      }
      const updatedPkg = manualStatus.status === 'Out for Delivery'
        ? { ...pkg, deliveryDate: manualStatus.deliveryDate, deliveryBoyDetails: deliveryBoy, deliveryBoyId: deliveryBoy?.id, orderActivity: [...(pkg.orderActivity||[]), newAct] }
        : { ...pkg, deliveryDate: manualStatus.deliveryDate, orderActivity: [...(pkg.orderActivity||[]), newAct] }
      await supabase.from('orders').update({ status: manualStatus.status, package_details: JSON.stringify(updatedPkg) }).eq('id', current.id)
      await emitOrderNotification({
        actorUserId,
        order: { ...current, status: manualStatus.status, package_details: updatedPkg },
        recipientUserIds: manualStatus.status === 'Out for Delivery' ? [deliveryBoy?.id] : [],
        eventType: 'order_status_updated',
        title: 'Order status updated',
        message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} changed to ${manualStatus.status}.`,
        metadata: {
          location: manualStatus.location,
          remark: manualStatus.remark,
          deliveryDate: manualStatus.deliveryDate,
        },
      })
      if (String(manualStatus.status).toLowerCase() === 'delivered') {
        await syncDeliveryAssignmentStatusForOrder({ ...current, status: manualStatus.status, package_details: updatedPkg })
      }
      setOrderDetail(prev => ({ ...prev, orderStatus: manualStatus.status, deliveryDate: manualStatus.deliveryDate, orderActivity: updatedPkg.orderActivity }))
    }
    handleUpdateModal()
  }
  const fetchDeliveryBoy = async () => {
    const { data, error } = await supabase.from('users').select('*').in('role', ['Delivery Boy','Delivery Partner']).eq('service','logistics')
    if (error) return
    const list = (data || []).map(u => ({ id: u.id, name: u.name, phone: u.contact, email: u.email }))
    setDeliveryBoys(list)
  }
  // Helper: fetch order row by UUID id or by tracking/order number
  const getOrderRow = async (paramId) => {
    const uuidRe = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
    // Try by UUID id first
    if (uuidRe.test(String(paramId))) {
      const { data, error } = await supabase.from('orders').select('*').eq('id', paramId).single()
      if (!error && data) return data
    }
    // Try by tracking_number
    let res = await supabase.from('orders').select('*').eq('tracking_number', paramId).single()
    if (!res.error && res.data) return res.data
    // Try by order_id
    res = await supabase.from('orders').select('*').eq('order_id', paramId).single()
    if (!res.error && res.data) return res.data
    // Try by order_number
    res = await supabase.from('orders').select('*').eq('order_number', paramId).single()
    if (!res.error && res.data) return res.data
    return null
  }

  const handleDeliveryStatus = () => {
    dispatch(generateToken())
    if (shippingToken?.jwt?.length !== 0 && orderDetail?.forwardingNumber) {
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: 'https://btob.api.delhivery.com/v3/track/' + orderDetail.forwardingNumber,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + shippingToken.jwt
        }
      }
      axios(config)
        .then(async (response) => {
          const date = new Date()
          const data = response?.data?.data
          const status = data?.wbns?.[0]?.status
          const remark = data?.wbns?.[0]?.scan_remark
          const location = data?.wbns?.[0]?.location

          // Load current order (handle non-UUID ids)
          const current = await getOrderRow(id)
          if (!current) throw new Error('Order not found for id/track/order: ' + id)
          const pkg = parseJSON(current?.package_details) || {}
          const newActivity = { status, remark, location, time: date }

          if (status === 'DELIVERED') {
            const updatedPkg = { ...pkg, orderActivity: [...(pkg.orderActivity || []), newActivity] }
            await supabase.from('orders').update({ status: 'delivered', package_details: updatedPkg }).eq('id', current.id)
            await emitOrderNotification({
              actorUserId,
              order: { ...current, status: 'delivered', package_details: updatedPkg },
              eventType: 'order_delivered',
              title: 'Order delivered',
              message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} was delivered.`,
              metadata: { source: 'partner_tracking' },
            })
            await syncDeliveryAssignmentStatusForOrder({ ...current, status: 'delivered', package_details: updatedPkg })
            setOrderDetail(prev => ({ ...prev, orderStatus: 'delivered', orderActivity: updatedPkg.orderActivity }))
            // Fetch POD
            const podCfg = {
              method: 'get',
              maxBodyLength: Infinity,
              url: 'https://btob.api.delhivery.com/v3/document/' + orderDetail.forwardingNumber + '?doc_type=LM_POD',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + shippingToken.jwt
              }
            }
            const podRes = await axios(podCfg)
            const podUrl = podRes?.data?.data?.[0]
            const { data: cur2 } = await supabase.from('orders').select('*').eq('id', current.id).single()
            const pkg2 = parseJSON(cur2?.package_details) || {}
            const upd2 = { ...pkg2, pod: podUrl }
            await supabase.from('orders').update({ package_details: JSON.stringify(upd2) }).eq('id', current.id)
            setOrderDetail(prev => ({ ...prev, pod: podUrl }))
          } else {
            const updatedPkg = { ...pkg, orderActivity: [...(pkg.orderActivity || []), newActivity] }
            await supabase.from('orders').update({ package_details: JSON.stringify(updatedPkg) }).eq('id', current.id)
            await emitOrderNotification({
              actorUserId,
              order: { ...current, package_details: updatedPkg },
              eventType: 'order_tracking_updated',
              title: 'Tracking update received',
              message: `Order ${current?.tracking_number || current?.order_number || current?.order_id || ''} received a ${status || 'tracking'} update.`,
              metadata: { status, location, remark },
            })
            setOrderDetail(prev => ({ ...prev, orderActivity: updatedPkg.orderActivity }))
          }
        })
        .catch((error) => {
          alert('Error:' + error.message)
        })
    }
  }
  const addPOD = async (e) => {
    e.preventDefault()
    setloadingPod(true)
    const file = e.target[0]?.files[0]
    if (!file) {
      setloadingPod(false)
      return
    }
    try {
      const path = `pod/${id}_${Date.now()}_${file.name}`
      const { error: uploadError } = await uploadFile('documents', path, file)
      if (uploadError) throw uploadError
      
      const url = getFileUrl('documents', path)
      
      // Get current order - handle both UUID and tracking/order number
      const current = await getOrderRow(id)
      if (!current) {
        throw new Error('Order not found')
      }
      
      const pkg = parseJSON(current?.package_details) || {}
      const updatedPkg = { ...pkg, pod: url }
      
      // Update with JSON stringified package_details
      const { error: updateError } = await supabase
        .from('orders')
        .update({ package_details: JSON.stringify(updatedPkg) })
        .eq('id', current.id)
      
      if (updateError) {
        console.error('Update error:', updateError)
        throw updateError
      }
      
      // Update local state
      setOrderDetail(prev => ({ ...prev, pod: url }))
      if (String(current?.status).toLowerCase() === 'delivered') {
        await syncDeliveryAssignmentStatusForOrder({ ...current, package_details: updatedPkg })
      }
      
      // Show success message
      toast.success('POD uploaded successfully!')
      
      // Reset form
      e.target.reset()
      
      setloadingPod(false)
    } catch (err) {
      console.error('POD upload error:', err)
      toast.error('Failed to upload POD: ' + (err.message || 'Unknown error'))
      setloadingPod(false)
    }
  }
  console.log(orderDetail)
  const fetchOrderDetail = async () => {
    let row = null
    let { data, error } = await supabase.from('orders').select('*').eq('id', id).single()
    if (error) {
      const byTrack = await supabase.from('orders').select('*').eq('tracking_number', id).single()
      if (!byTrack.error) { row = byTrack.data } else {
        const byOrderId = await supabase.from('orders').select('*').eq('order_id', id).single()
        if (!byOrderId.error) {
          row = byOrderId.data
        } else {
          const byOrder = await supabase.from('orders').select('*').eq('order_number', id).single()
          if (!byOrder.error) row = byOrder.data
        }
      }
    } else {
      row = data
    }
    if (!row) return
    const pkg = parseJSON(row.package_details) || {}
    const mapped = {
      id: row.id,
      lrno: row.tracking_number || row.order_number,
      orderID: row.order_id || row.order_number || '',
      forwardingNumber: row.forwarding_number || '',
      forwardingPartner: row.forwarding_partner || pkg.partner || '',
      deliveryWaybill: pkg.deliveryWaybill || [],
      deliveryMasterWaybill: pkg.deliveryMasterWaybill || '',
      orderStatus: row.status,
      dropoff_location: parseJSON(row.delivery_address) || {},
      pickup_location: parseJSON(row.pickup_address) || {},
      invoices: pkg.invoices || [],
      dimensions: parseJSON(row.dimensions) || [],
      weight: row.weight,
      shippingType: pkg.shipping_type || '',
      consignee_gst_tin: pkg.consignee_gst_tin,
      seller_gst_tin: pkg.seller_gst_tin,
      job_id: pkg.job_id || row.job_id,
      orderActivity: (pkg.orderActivity || []).map(a => ({ ...a, time: new Date(a.time) })),
      pod: pkg.pod || '',
      deliveryDate: pkg.deliveryDate || '',
      undeliveredReason: pkg.undelivered_reason || '',
      undeliveredPod: pkg.undelivered_pod || ''
    }
    setOrderDetail(mapped)
    setOrderActivity(mapped.orderActivity)
  }
  console.log(orderDetail)
  useEffect(() => {
    fetchOrderDetail()
    fetchDeliveryBoy()

  }, [id])
  const MINUTE_MS = 2000;

  useEffect(() => {



  }, [])

  return (
    <div className='bg-gray-50 flex min-h-screen'>
      <Toaster />
      <UpdateStatusModal deliveryBoy={deliveryBoy} setDeliveryBoy={setDeliveryBoy} deliveryBoys={deliveryBoys} setDeliveryBoys={setDeliveryBoys} handleDeliveryStatus={handleDeliveryStatus} updateModal={updateModal} setUpdateModal={setUpdateModal} handleUpdateModal={handleUpdateModal} manualStatus={manualStatus} setManualStatus={setManualStatus} handleManulOrder={handleManulOrder} />
      <Sidebar />
      <div className='h-[100vh] overflow-y-scroll flex flex-1 flex-col' >
        <Topbar />
        <div className='flex-1 pb-6'>
          <ViewOrderDetails loadingPod={loadingPod} id={id} addPOD={addPOD} handleUpdateModal={handleUpdateModal} generateForwardingNumber={generateForwardingNumber} orderDetails={orderDetail} />
        </div>
      </div>
    </div>
  )
}

export default ViewOrder
